import { rankWith, schemaMatches } from '@jsonforms/core';

export default rankWith(
  10, //increase rank as needed
  schemaMatches((schema) => schema.hasOwnProperty('items') &&
    (schema.hasOwnProperty('type') && schema['type'] === 'array') &&
    (schema.hasOwnProperty('uniqueItems') && schema['uniqueItems']))
);
